import React from 'react';
import { Eye } from 'lucide-react';

const BillCard = ({ bill, onViewBill, layout = 'row' }) => {
  const { invoiceNumber, imageUrl, createdAt } = bill;

  const formattedDate = createdAt 
    ? new Date(createdAt).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' }) 
    : '';

  if (layout === 'grid') {
    return (
      <div className="bill-card-item">
        <div className="bill-image-preview-box" onClick={() => onViewBill(bill)}>
          <img src={imageUrl} alt={invoiceNumber} />
        </div>
        <div className="bill-card-details">
          <div className="bill-info-meta">
            <span className="bill-invoice-no">{invoiceNumber}</span>
            <span className="bill-upload-date">{formattedDate}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
            <button onClick={() => onViewBill(bill)} className="btn-view-details" style={{ display: 'flex', alignItems: 'center', gap: '6px', width: '100%', justifyContent: 'center' }}>
              <Eye size={14} /> View Invoice
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Row layout (default recent panel style)
  return (
    <div className="recent-item-row bill-row-item">
      <div className="recent-item-left">
        <div className="recent-item-thumbnail-box" onClick={() => onViewBill(bill)}>
          {imageUrl ? (
            <img src={imageUrl} alt={invoiceNumber} className="bill-thumbnail-img" />
          ) : (
            <span className="bill-thumbnail-fallback">📄</span>
          )}
        </div>
        <div className="recent-item-info">
          <span className="recent-item-title">{invoiceNumber}</span>
          <span className="recent-item-subtitle">{formattedDate}</span>
        </div>
      </div>

      <div className="recent-item-right">
        <button onClick={() => onViewBill(bill)} className="btn-view-details" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <Eye size={14} /> View Invoice
        </button>
      </div>
    </div>
  );
};

export default BillCard;
